<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">Copyright © 2021 All rights reserved.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1">Version {{ $store.state.version }}</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
